import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Layers, MessageCircleQuestion, Sparkles } from 'lucide-react';

/**
 * Selecionar texto dentro de containerRef abre 3 ações (2a): Explicar, Me pergunte, Virar flashcard.
 * onAction(kind, text) com kind = explain | quiz | flashcard.
 */
export function SelectionActions({ containerRef, onAction, disabled = false }) {
  const [sel, setSel] = useState(null);

  useEffect(() => {
    if (disabled) return undefined;
    const update = () => {
      const s = window.getSelection();
      const text = s?.toString().trim();
      const root = containerRef.current;
      if (!text || text.length < 3 || !s.rangeCount || !root || !root.contains(s.anchorNode) || !root.contains(s.focusNode)) {
        setSel(null);
        return;
      }
      const r = s.getRangeAt(0).getBoundingClientRect();
      setSel({ text: text.slice(0, 3000), top: r.top + window.scrollY, left: r.left + r.width / 2 + window.scrollX });
    };
    const onUp = () => setTimeout(update, 0);
    const onKey = (e) => { if (e.key === 'Escape') setSel(null); };
    document.addEventListener('mouseup', onUp);
    document.addEventListener('keyup', onUp);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mouseup', onUp);
      document.removeEventListener('keyup', onUp);
      document.removeEventListener('keydown', onKey);
    };
  }, [containerRef, disabled]);

  if (!sel) return null;
  const run = (kind) => (e) => {
    e.preventDefault();
    onAction(kind, sel.text);
    window.getSelection()?.removeAllRanges();
    setSel(null);
  };
  return createPortal(
    <div className="ai-selbar" style={{ top: sel.top - 48, left: sel.left }} role="toolbar" aria-label="Ações com o trecho"
         onMouseDown={(e) => e.preventDefault()}>
      <button type="button" className="is-primary" onMouseUp={run('explain')}><Sparkles size={13} aria-hidden="true" />Explicar</button>
      <button type="button" onMouseUp={run('quiz')}><MessageCircleQuestion size={13} aria-hidden="true" />Me pergunte</button>
      <button type="button" onMouseUp={run('flashcard')}><Layers size={13} aria-hidden="true" />Virar flashcard</button>
    </div>,
    document.body,
  );
}
